export default {
  Ingress: "Ingress",
  ingressName: "Ingress名称",
  useHTTPS: "是否启用HTTPS",
  ingressSubHost: "子路径",
  ingressRules: "转发规则"
};
